<script lang="ts">

    export let ratio: number = 1;

</script>

<div class="aspect-ratio" style="--ratio: {ratio}">
    <div class="content">
        <slot />
    </div>
</div>

<style lang="scss">

    .aspect-ratio {
        position: relative;
        width: 100%;

        &::before {
            content: '';
            display: block;
            padding-top: calc(100% * var(--ratio));
        }
    }

    .content {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

</style>
